<template>

    <div class="table-container">

        <table class="table table-striped table-hover display table-discounts">
            <thead class="thead_wrapper">
            <tr>
                <th colspan="10" class="p-3">Bestandsnaam</th>
                <th colspan="10" class="p-3 sorting bp-35" @click="sortFilesByDate">Ingelezen op</th>
                <th colspan="1" class="p-3"></th>
            </tr>
            </thead>

            <tbody>
            <tr v-if="!filesUnderProcessing &&  !filesProcessed">
                <td colspan="10">
                    <em>Er zijn geen bestanden.</em>
                </td>
            </tr>
            </tbody>

            <tbody>
            <tr
                v-for="(file ,key ) in filesUnderProcessing"
                :class=" key % 2 === 0 ?'start-group' :''">
                <td colspan="10">{{ file['name'] }}</td>
                <td colspan="10">{{ file['date'] }}</td>
                <td><img class="w-px-25" src="/assets/images/refresh.svg"></td>
            </tr>
            <tr
                v-for="(file ,key ) in filesProcessed"
                :class=" key % 2 === 0 ?'start-group' :''">
                <td colspan="10">{{ file['name'] }}</td>
                <td colspan="10">{{ file['date'] }}</td>
                <td><img class="w-px-20" src="/assets/images/check-green.svg"></td>
            </tr>

            </tbody>
        </table>
    </div>
</template>°

<script>

    export default {
        props: {
            filesUnderProcessing: Array,
            filesProcessed: Array,
        },
        data() {
            return {
                sortDirection: 1, // 1 for asc, -1 for desc
            };
        },
        methods: {
            sortFilesByDate() {
                this.sortDirection *= -1;
                if (this.sortDirection === 1) {
                    this.filesUnderProcessing.sort((a, b) => new Date(a.date) - new Date(b.date));
                    this.filesProcessed.sort((a, b) => new Date(a.date) - new Date(b.date));
                } else {
                    this.filesUnderProcessing.sort((a, b) => new Date(b.date) - new Date(a.date));
                    this.filesProcessed.sort((a, b) => new Date(b.date) - new Date(a.date));
                }
                this.$forceUpdate();
            },
        },
    }
</script>

<style>
    .bp-35{
        background-position: 35% !important;
    }

</style>
